module.exports = __webpack_public_path__ + "static/img/19.ca6e831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/19.png
// module id = orKP
// module chunks = 0